import Web3 from "web3";
import Web3Modal from "web3modal";
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import WalletConnectProvider from "@walletconnect/web3-provider";

export interface WalletContextState {
  walletAddress?: string;
  web3?: Web3;
  connectWallet: () => Promise<string>;
}

const WalletContext = createContext<WalletContextState>(
  {} as WalletContextState
);

function useWallet(): WalletContextState {
  return useContext(WalletContext);
}

const WalletProvider = (props: React.PropsWithChildren<{}>) => {
  const [web3, setWeb3] = useState<Web3>();
  const [walletAddress, setWalletAddress] = useState<string>();

  const web3Modal = useMemo(() => {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          infuraId: "ff406d303d8942b581d6f378d90a6030", // required
        },
      },
    };
    return new Web3Modal({
      network: "mainnet", // optional
      cacheProvider: true, // optional
      providerOptions, // required
    });
  }, []);

  const connectWallet = async () => {
    const provider = await web3Modal.connect();

    const web3 = new Web3(provider);
    setWeb3(web3);

    const accounts = await web3.eth.getAccounts()
    setWalletAddress(accounts[0]);
    return accounts[0];
  };

  useEffect(() => {
    connectWallet();
  }, []);

  const value = useMemo(() => ({ web3, connectWallet, walletAddress }), [web3, walletAddress]);

  return (
    <WalletContext.Provider value={value}>
      {props.children}
    </WalletContext.Provider>
  );
};
export { WalletContext, WalletProvider, useWallet };
